import Attachment from 'models/Attachment';
import { ReviewType } from 'models/Review';

export function getSummaryButtonTooltip({
  reviewType,
  attachments,
  hasProcessingAttachments,
  allAttachmentsFailedProcessing,
}: {
  reviewType: ReviewType;
  attachments: Attachment[];
  hasProcessingAttachments: boolean;
  allAttachmentsFailedProcessing: boolean;
}): string {
  if (attachments.length === 0) {
    return `No files attached to the ${reviewType} yet.`;
  }
  if (hasProcessingAttachments) {
    return 'All files must finish processing before a summary can be generated.';
  }
  if (allAttachmentsFailedProcessing) {
    return 'All files have failed to process.';
  }
  return '';
}
